import { BRAND } from './entity-types'

export const LOCKABLE_ENTITIES = {
  BRAND,
}
